/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import {
  Row, Col,
} from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  FormItem,
  FormInput,
  CheckButton,
  ItemLabel,
} from './Forms';
import Countries from './Countires';
import { Field, FormViewType } from '../types';

const CheckVatNumber = ({
  findCompany, form, view, setDisabledCountrySelect,
}) => {
  const { t } = useTranslation();
  const [disabledCheckVatView, setDisabledCheckVatView] = useState(false);
  const [disabledCheckButton, setDisabledCheckButton] = useState(true);

  const resolveDisabledCheckButton = () => {
    if (!disabledCheckVatView && form.isFieldsTouched([Field.VAT_NUMBER], true)) {
      form.validateFields([Field.VAT_NUMBER])
        .then(() => setDisabledCheckButton(false))
        .catch(() => setDisabledCheckButton(true));
    }
  };

  const extractCountyCode = (vatNumber) => (
    vatNumber && vatNumber.match('^[A-Z]{2}') ? vatNumber.substring(0, 2) : undefined
  );

  const resolveVatCountryCode = (countryCode) => {
    if (Countries.containsCode(countryCode)) {
      return countryCode;
    }
    setDisabledCountrySelect(false);
    return undefined;
  };

  const setVatCountryCode = (vatNumber) => {
    const countryCode = extractCountyCode(vatNumber);
    form.setFieldsValue({ [Field.VAT_COUNTRY_CODE]: resolveVatCountryCode(countryCode) });
  };

  return (
    <>
      <Col span={1} />
      <Col span={19}>
        <FormItem
          marginBottom="-18px"
          style={{
            width: '100%',
            display: 'block',
            marginBottom: '0px',
          }}
          labelCol={{ span: 24 }}
          label={view === undefined || view === FormViewType.COMPLETED_FORM
            ? (<ItemLabel>{t('FORM_FILL_COMPANY.VAT_NUMBER_HEADER')}</ItemLabel>)
            : (<ItemLabel>{t('FORM_FILL_COMPANY.VAT_NUMBER_HEADER_2')}</ItemLabel>)}
          name={Field.VAT_NUMBER}
          rules={[
            {
              validator(_, value) {
                const countryCode = extractCountyCode(value);
                if (!countryCode) {
                  return Promise.reject(
                    new Error(t('FORM_FILL_COMPANY.VAT_NUMBER_VALIDATION_MSG')),
                  );
                }
                if (value.length < 4 || value.length > 14) {
                  return Promise.reject(
                    new Error(t('FORM_FILL_COMPANY.VAT_NUMBER_BETWEEN_4_AND_14')),
                  );
                }
                if (disabledCheckVatView && !Countries.containsCode(countryCode)) {
                  return Promise.reject(
                    new Error(t('FORM_FILL_COMPANY.VAT_NUMBER_INCORRECT_COUNTRY_CODE')),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <FormInput
            onChange={(e) => {
              const value = e.target.value.replace(/[^A-Za-z0-9]/gi, '').toUpperCase();
              form.setFieldsValue({ [Field.VAT_NUMBER]: value });
              resolveDisabledCheckButton();
              setVatCountryCode(value);
            }}
            placeholder={t('FORM_FILL_COMPANY.VAT_NUMBER_MASK')}
          />
        </FormItem>
      </Col>
      <Col span={4}>
        <Row
          align="middle"
          justify="space-between"
          style={{
            marginTop: '20px',
            marginLeft: '13px',
          }}
        >
          {disabledCheckVatView ? (<></>) : (
            <>
              <CheckButton
                style={disabledCheckButton ? { color: '#BDBDBD' } : { color: '#1890FF' }}
                disabled={disabledCheckButton}
                size="large"
                type="text"
                onClick={() => {
                  setDisabledCheckVatView(true);
                  findCompany();
                }}
              >
                {t('FORM_FILL_COMPANY.CHECK_BUTTON')}
              </CheckButton>
            </>
          )}
        </Row>
      </Col>
    </>
  );
};

export default CheckVatNumber;

CheckVatNumber.propTypes = {
  form: PropTypes.any.isRequired,
  findCompany: PropTypes.func.isRequired,
  view: PropTypes.any.isRequired,
  setDisabledCountrySelect: PropTypes.func.isRequired,
};
